import { useSearchParams } from 'react-router-dom';
import ResponsiveListContainer from '../../ResponsiveListContainer';

import { useCallback, useState } from 'react';
import Footer from './Footer';
import TitleComponent from './Title';
import { mockData } from './mock';
import SingleRow from './SingleRow';

const CreateNewReceiptMobileView = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id') || '1';
    const [data, setData] = useState(mockData);
    const [totalValue, setTotalValue] = useState(0);

    const updateTotalValue = useCallback((newTotal: number) => {
        setTotalValue((prev) => (prev !== newTotal ? newTotal : prev));
    }, []);

    return (
        <>
            <ResponsiveListContainer
                TitleComponent={TitleComponent}
                SingleRowComponent={<SingleRow updateTotalValue={updateTotalValue} />}
                mainContent={data}
                displaySearch={false}
                FooterComponent={<Footer initialValue={totalValue} updateInitialValue={updateTotalValue} />}
            />
        </>
    );
};

export default CreateNewReceiptMobileView;
